import React from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import '../../../../App.css';
import { useEffect } from 'react';
import LoginLayout from '../../../layouts/loginlayout'
import { toast } from 'react-toastify';


export default () => {

    const navigate = useNavigate();
    let { userstate } = useParams();

    useEffect(() => {
        localStorage.setItem('mdmsstate', 'login');
        sessionStorage.removeItem('user_name');
        sessionStorage.removeItem('access_token');
        sessionStorage.removeItem('id_token');
        sessionStorage.removeItem('expires_in');
        sessionStorage.removeItem('auth_code');
        document.getElementById('alertMessage').innerHTML = '';
        sessionStorage.clear();
        sessionStorage.setItem('userstate', userstate);
    }, [])

    return (

        <LoginLayout>
            <div>

                <div className='d-grid gap-3 w-100 text-center loginControl'>
                    <div className='d-grid gap-3'>
                        <div id='alertMessage' role="alert">
                        </div>
                    </div>
                </div>

            </div>
        </LoginLayout>
    )

}